<script setup lang="ts">
type TestData = App.Students.Data.TestData;

import { ButtonSize } from '@/hooks/useButtonClasses';

import { useChatBot } from '@/domains/chat/composables/useChatBot';

import Button from '@/components/button/Button.vue';
import Dialog from '@/components/dialog/Dialog.vue';
import SubmissionCardsList from '@/components/studentParentApp/SubmissionCardsList.vue';

import Plus from '@/icons/line/plus.svg';

defineProps<{
  tests: TestData[];
}>();

const { enableChatBotForStudents } = useChatBot();
const { show, closeLocally } = useDialog();
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/student-parent.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <Dialog
    title="Submit Test Information"
    :isOpen="show"
    fit="fill"
    @onClose="closeLocally"
    :showAiAdviser="enableChatBotForStudents"
  >
    <template #form>
      <SubmissionCardsList :items="tests" type="test" title="Existing Tests" />
    </template>
    <template #footer>
      <div class="border-t border-slate-300 px-5 py-3.5">
        <Button
          class="w-full"
          :href="route('student.data-requests.create-test.create')"
          :size="ButtonSize.lg"
          :iconLeft="Plus"
          >Add Test</Button
        >
      </div>
    </template>
  </Dialog>
</template>
